<template>
  <div style="padding-left:5px;padding-right:5px;">
    <ConfirmDialog
      :dialog="showConfirmDelete"
      @modalResult="confirmDeleteTargetDialogResult"
      title="Delete Target"
      :text=getDeleteText()
      yesColor="#f5f5f5"
    >
    </ConfirmDialog>

    <CreateNewEasyTargetDialog
      :dialog="showCreateNewEasyTargetDialog"
      @close="closeCreateNewEasyTargetDialog"
    >
    </CreateNewEasyTargetDialog>

    <ModifyEasyTargetDialog
      :dialog="showModifyEasyTargetDialog"
      :targetName="target.targetName"
      :targetId="target.targetId"
      :packageName="target.packageName"
      :packageIndex="target.packageIndex"
      @close="closeModifyEasyTargetDialog"
    >
    </ModifyEasyTargetDialog>

    <v-card flat>
      <v-data-table
        class="mt-5"
        single-select
        :footer-props="{ disableItemsPerPage: true, showFirstLastPage: true, showCurrentPage: true  }"
        :headers="headers"
        :loading="busy"
        :items="targets"
        :items-per-page="10"
        :server-items-length="serverItemsLength"
        :options.sync="options"
      >
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-if="canManageTargets()" @click.stop="openModifyTargetDialog(item)" v-on="on">edit</v-icon>
            </template>
            <span>Edit Target</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-if="canManageTargets()" @click.stop="openConfirmDeleteDialog(item)" v-on="on" style="color:red;">delete_forever</v-icon>
            </template>
            <span>Delete Target</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-card-actions v-if="canManageTargets()">
        <div class="flex-grow-1"></div>
        <v-btn
          @click.stop="openCreateNewEasyTargetDialog()"
          :loading="creatingEasyTarget"
        >
          Create New Target
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar
      v-model="alertVisible"
      timeout="10000"
    >
      {{ alertText }}
      <v-btn
        color="pink"
        text
        @click="alertVisible = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment';
import ConfirmDialog from '../ConfirmDialog.vue';
import CreateNewEasyTargetDialog from './CreateNewEasyTargetDialog.vue';
import ModifyEasyTargetDialog from './ModifyEasyTargetDialog.vue';

export default {
  components: {
    ConfirmDialog,
    CreateNewEasyTargetDialog,
    ModifyEasyTargetDialog,
  },

  data() {
    return {
      showCreateNewEasyTargetDialog: false,
      creatingEasyTarget: false,
      showModifyEasyTargetDialog: false,
      modifyingEasyTarget: false,

      alertVisible: false,
      alertText: false,

      showConfirmDelete: false,

      options: {},
      busy: false,
      serverItemsLength: 0,
      targets: [],
      target: {},

      headers: [
        {
          text: 'Target Name',
          align: 'left',
          sortable: false,
          value: 'targetName',
          width: 150,
        },
        {
          text: 'Target ID',
          align: 'left',
          sortable: false,
          value: 'targetId',
          width: 150,
        },
        {
          text: 'Package Index',
          align: 'left',
          sortable: false,
          value: 'packageIndex',
          width: 150,
        },
        {
          text: 'Package Name',
          align: 'left',
          sortable: false,
          value: 'packageName',
          width: 150,
        },
        {
          text: 'Actions',
          align: 'left',
          sortable: false,
          value: 'action',
          width: 150,
        },
      ],
    };
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    canManageTargets() {
      return (
        this.$store.state.auth.token
        && (
          this.$store.state.auth.token.user.role === 'admin'
          || this.$store.state.auth.token.user.role === 'engineer'
        )
      );
    },

    getData() {
      const options = {
        method: 'get',
        url: `/api/v1/ez_get_targets/?page=${this.options.page || 1}`,
      };

      this.target = {};
      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;
          this.serverItemsLength = res.data.totalDocs;
          this.targets = res.data.docs.map((cur) => {
            const { createdAt, updatedAt, ...rest } = cur;
            const created = moment(createdAt);
            const updated = moment(updatedAt);
            return Object.assign({}, {
              createdAt: created.local().format('YYYY-MM-DD HH:mm:ss'),
              updatedAt: updated.local().format('YYYY-MM-DD HH:mm:ss'),
            }, rest);
          });
        })
        .catch((err) => {
          this.busy = false;
        });
    },

    openCreateNewEasyTargetDialog() {
      this.showCreateNewEasyTargetDialog = true;
    },

    closeCreateNewEasyTargetDialog(value) {
      this.showCreateNewEasyTargetDialog = false;

      if (value && value.packageName && value.packageIndex >= 0 && value.targetName && value.targetId >= 0) {
        this.creatingEasyTarget = true;

        const options = {
          method: 'post',
          url: '/api/v1/create_ez_target',
          data: {
            packageIndex: value.packageIndex,
            packageName: value.packageName,
            targetId: value.targetId,
            targetName: value.targetName,
          },
        };

        this.axios(options)
          .then((res) => {
            this.creatingEasyTarget = false;
            console.log(`... create target res ${res.status}`);

            if (res.status === 201) {
              this.alertText = `EZ ADAS target ${value.targetName} created`;
              this.alertVisible = true;

              this.getData();
            } else {
              console.log(`create target failed with ${res.status}`);
              this.alertText = 'EZ ADAS target creation failed';
              this.alertVisible = true;
            }

            this.target = {};
          });
      }
    },

    openModifyTargetDialog(target) {
      console.log('open modify target');
      this.target = target;
      this.showModifyEasyTargetDialog = true;
    },

    closeModifyEasyTargetDialog(value) {
      if (value && value.targetName) {
        this.modifyingEasyTarget = true;

        const options = {
          method: 'post',
          url: '/api/v1/update_ez_target',
          data: {
            targetName: value.targetName,
            targetId: value.targetId,
            packageName: value.packageName,
            packageIndex: value.packageIndex,
          },
        };

        this.axios(options)
          .then((res) => {
            this.modifyingEasyTarget = false;
            this.target = {};

            if (res.status === 200) {
              this.alertText = `EZ ADAS ${value.targetName} target updated`;
              this.alertVisible = true;

              this.getData();
            }
          })
          .catch((err) => {
            if (err.response.status === 404) {
              this.alertText = `EZ ADAS target ${value.target} does not exist`;
              this.alertVisible = true;
            } else {
              this.alertText = 'EZ ADAS update target failed';
              this.alertVisible = true;
            }
          });
      }

      this.showModifyEasyTargetDialog = false;
    },

    getDeleteText() {
      return (`Are you sure you want to delete ${this.target.targetName}?`);
    },

    openConfirmDeleteDialog(target) {
      this.target = target;
      this.showConfirmDelete = true;
    },

    confirmDeleteTargetDialogResult(confirmed) {
      if (confirmed) {
        const options = {
          method: 'post',
          url: '/api/v1/delete_ez_target',
          data: {
            targetName: this.target.targetName,
          },
        };

        this.axios(options)
          .then((res) => {
            this.showConfirmDelete = false;
            this.target = {};

            this.getData();
          });
      } else {
        this.showConfirmDelete = false;
        this.target = {};
      }
    },
  },
};
</script>
